<template>
<div v-if="dialogVisible">
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="650px"
    center
    @close="dialogClose"
    :close-on-click-modal="false">
    <div class="depart">
      <el-form :model="companyData" label-width="100px" :rules="rules" ref="ruleForm">
        <el-row>
          <el-col>
            <el-form-item label="供应商类型：" style="margin-top: 10px" prop="type" label-width="130px">
              <el-select
                v-model="companyData.type" filterable  :disabled="disabled" size="small" style="width: 100%"
                placeholder="请选择供应商类型" value-key="id"  @change="supplierName">
                <el-option label='公路' :value='0' />
                <el-option label='水路' :value='1' />
                <el-option label='港口及其他' :value='2' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="供应商："  prop="supplierName">
              <el-select
                v-model="companyData.supplierName" size="small" filterable clearable  :disabled="disabled"
                style="width: 100%" placeholder="请选择供应商" value-key="id"  @change="getContract">
                <el-option
                  v-for="item in supplierList" :key="item.id"
                  :label="item.name" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="合同名称：" style="margin-top: 10px; margin-bottom: 10px" prop="contractName">
              <el-select
                v-model="companyData.contractName" filterable clearable  :disabled="disabled" size="small" style="width: 100%"
                placeholder="请选择合同" value-key="id" @change="selectContract">
                <el-option
                  v-for="item in contractList" :key="item.id"
                  :label="item.name" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="合同编号：" style="margin-top: 10px; margin-bottom: 10px" prop="contractCode">
              <el-input v-model="companyData.contractCode" size="small" disabled style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="对账时间：" style="margin-top: 10px; margin-bottom: 10px" prop="reconciliationTime">
              <span>每月</span><el-input v-model="companyData.dayAfter" size="small" style="width: 97px"  placeholder="请输入日期"/><span>日后，</span>
              <span>可对</span><el-input v-model="companyData.monthDate" size="small" style="width: 97px"  placeholder="请输入月份"/><span>月前，</span>
              <el-input v-model="companyData.dayBefore" size="small" style="width: 97px"  placeholder="请输入日期"/><span>日之前的账</span>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="开始时间：" prop="startDate" style="margin-bottom: 20px">-->
<!--              <el-date-picker-->
<!--                v-model="companyData.startDate"-->
<!--                size="small"-->
<!--                type="datetime"-->
<!--                style="width: 100%"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                placeholder="请选择有效开始时间" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="结束时间：" prop="endDate">-->
<!--              <el-date-picker-->
<!--                v-model="companyData.endDate"-->
<!--                size="small"-->
<!--                type="datetime"-->
<!--                style="width: 100%"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                placeholder="请选择有效结束时间"-->
<!--                default-time="23:59:59"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
        <div class="btnContainer">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定
          </el-button>
          <el-button size="medium" class="resetBtn" @click="dialogClose">取消</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</div>
</template>
<script>
import {customerInfoSelectList, getHighwayParam} from "@/service/basicfile";
import {contractPageList, highwayLineSelectWaterSupplier} from "@/service/financial";
import {getModelList} from "@/service/vehiclelog";
import {
  addContracts,
  addRevenue,
  detailRevenue,
  getSupplierPortOtherInfo, updateContract,
  updateRevenue
} from "@/service/warehouse";

export default {
  data(){
    return{
      dialogTitle: '',
      dialogVisible: false,
      companyData:{
        supplierName: '',
        type: '',
        contractName: '',
        contractCode: '',
        monthDate: '',
        dayBefore: '',
        dayAfter: '',
        startDate: '',
        endDate: ''
      },
      contractList: [],
      supplierList: [],
      typeList: [],
      disabled: false,
      addLoad: false,
      checked: false,
      rules: {
        type: [
          {
            required: true,
            message: '请选择供应商类型',
            trigger: 'blur',
          },
        ],
        supplierName: [
          {
            required: true,
            message: '请选择供应商',
            trigger: 'blur',
          },
        ],
        contractName: [
          {
            required: true,
            message: '请选择合同名称',
            trigger: 'blur',
          },
        ],
        contractCode: [
          {
            required: true,
            message: '请选择合同编号',
            trigger: 'blur',
          },
        ],
        monthDate: [
          {
            required: true,
            message: '请输入日期',
            trigger: 'blur',
          },
        ],
        dayBefore: [
          {
            required: true,
            message: '请输入月份',
            trigger: 'blur',
          },
        ],
        dayAfter: [
          {
            required: true,
            message: '请输入日期',
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: true,
            message: '请选择开始日期',
            trigger: 'blur',
          },
        ],
        endDate: [
          {
            required: true,
            message: '请选择结束日期',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.companyData));
  },
  methods:{
    dialogOpen(title,row) {
      this.dialogTitle = title;
      if(title === '修改'){
        this.disabled = true
        this.companyData = {
          ...row,
          supplierName: {
            id: row.supplierId,
            name: row.supplierName
          },
          contractName: {
            id: row.contractId,
            name: row.codeNumber + '-' + row.contractName,
            contractName: row.contractName
          }
        }
        this.supplierName(row.type)
        this._contractPageList(row.supplierName)
      }
      this.dialogVisible = true;
    },
    dialogClose() {
      this.dialogVisible = false;
      this.companyData.type = ''
      this.companyData.supplierName = ''
      this.companyData.contractName = ''
      this.companyData.monthDate = ''
      this.companyData.dayBefore = ''
      this.companyData.dayAfter = ''
    },
    // 获取供应商
    async supplierName(type) {
      if (type == 0) {
        const res = await getHighwayParam('');
        this.supplierList = res.data;
      } else if (type == 1) {
        const res = await highwayLineSelectWaterSupplier('');
        this.supplierList = res.data;
      }else {
        const res = await getSupplierPortOtherInfo('');
        this.supplierList = res.data.map(item =>{
          return {
            id: item.id,
            name: item.supplierName
          }
        })
      }
    },
    // 获取合同
    getContract(val) {
      this._contractPageList(val)
    },
    async _contractPageList() {
      let obj = {
        companyName: this.companyData.supplierName.name,
      };
      let res = await contractPageList(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.contractList = res.data.map(item =>{
        return {
          id: item.id,
          contractName: item.contractName,
          codeNumber: item.codeNumber,
          name: item.name
        }
      })
    },
    selectContract(){
      const item = this.contractList.find(item => item.id === this.companyData.contractName.id);
      this.companyData.contractCode = item.codeNumber;
    },
    addClick(){
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let data;
          if (this.companyData.id) {
            this.addLoad = true
            data = await updateContract({
              id: this.companyData.id,
              supplierName: this.companyData.supplierName.name,
              supplierId: this.companyData.supplierName.id,
              contractName: this.companyData.contractName.contractName,
              contractId: this.companyData.contractName.id,
              contractCode: this.companyData.contractCode,
              monthDate: this.companyData.monthDate,
              dayBefore: this.companyData.dayBefore,
              dayAfter: this.companyData.dayAfter,
              type: this.companyData.type,
              startDate: this.companyData.startDate,
              endDate: this.companyData.endDate,
              isDel: 0,
            });
            this.addLoad = false
          } else {
            this.addLoad = true
            data = await addContracts({
              supplierName: this.companyData.supplierName.name,
              supplierId: this.companyData.supplierName.id,
              contractName: this.companyData.contractName.contractName,
              contractId: this.companyData.contractName.id,
              contractCode: this.companyData.contractCode,
              type: this.companyData.type,
              monthDate: this.companyData.monthDate,
              dayBefore: this.companyData.dayBefore,
              dayAfter: this.companyData.dayAfter,
              startDate: this.companyData.startDate,
              endDate: this.companyData.endDate,
              isDel: 0,
            });
            this.addLoad = false
          }
          if (data.status !== -1) return this.$message.error(data.message);
          this.$message.success(data.message);
          this.$emit('searchBtn');
          this.dialogClose();
        }
      });
    }
  }
}
</script>


<style scoped lang="scss">

</style>
